module.exports = __webpack_public_path__ + "static/media/plus.a7afebba.svg";